import React, { useEffect, useMemo, useState } from "react";
import { Global } from "../helpers/Global";

const ESTADOS = [
  { id: "pendiente", titulo: "Pendiente" },
  { id: "en_curso", titulo: "En curso" },
  { id: "resuelta", titulo: "Resuelta" },
  { id: "rechazada", titulo: "Rechazada" },
  { id: "cancelada", titulo: "Cancelada" },
];

const Toast = ({ type = "info", children }) => {
  if (!children) return null;
  const base = {
    position: "fixed",
    top: 80,
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 9999,
    padding: "10px 16px",
    borderRadius: 8,
    fontWeight: 600,
    boxShadow: "0 6px 20px rgba(0,0,0,.12)",
    maxWidth: "90vw",
    textAlign: "center",
  };
  const variants = {
    ok: { background: "#e7f8ed", color: "#0f5132", border: "1px solid #b6f0c6" },
    error: { background: "#fdeceb", color: "#842029", border: "1px solid #f5c2c7" },
    info: { background: "#e8f6ff", color: "#084298", border: "1px solid #b6d9ff" },
  };
  return <div style={{ ...base, ...(variants[type] || {}) }}>{children}</div>;
};

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});
const authHeadersJson = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

const formatearFechaCompleta = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString();
};

const badgePrioridadClass = (p) => `badge-prioridad badge-prioridad--${p || "normal"}`;

const getIniciales = (usuario) => {
  const nombre = (usuario?.nombre || "").trim();
  const apellidos = (usuario?.apellidos || "").trim();
  const n1 = nombre ? nombre.split(" ")[0][0] : "";
  const a1 = apellidos ? apellidos.split(" ")[0][0] : "";
  const combo = (n1 + a1).toUpperCase();
  if (combo) return combo;
  if (nombre) return nombre[0].toUpperCase();
  return "?";
};

const sortPrioridad = (p) => {
  const pr = String(p || "normal").toLowerCase();
  if (pr === "critica") return 1;
  if (pr === "alta") return 2;
  if (pr === "normal") return 3;
  if (pr === "baja") return 4;
  return 99;
};

export const DashboardGlobal = () => {
  const [toast, setToast] = useState(null);

  const [cargando, setCargando] = useState(true);
  const [dashboard, setDashboard] = useState(null);

  // usuarios para mostrar nombres + resolver responsable
  const [usuariosMapa, setUsuariosMapa] = useState({});

  // filtros opcionales
  const [desde, setDesde] = useState("");
  const [hasta, setHasta] = useState("");

  // panel gestionar (modal)
  const [panelAbierto, setPanelAbierto] = useState(false);
  const [itemPanel, setItemPanel] = useState(null);

  const [usuariosDepto, setUsuariosDepto] = useState([]);
  const [cargandoUsuariosDepto, setCargandoUsuariosDepto] = useState(false);

  const [selectedUsuarioId, setSelectedUsuarioId] = useState("");
  const [nuevoEstado, setNuevoEstado] = useState("");
  const [comentarioAccion, setComentarioAccion] = useState("");
  const [guardandoPanel, setGuardandoPanel] = useState(false);

  const mostrarToast = (type, text) => {
    setToast({ type, text });
    setTimeout(() => setToast(null), 3200);
  };

  const construirEndpoint = () => {
    const qs = new URLSearchParams();
    if (desde) qs.set("desde", desde);
    if (hasta) qs.set("hasta", hasta);
    // si algún día quieres: qs.set("soloAbiertas","1");
    const q = qs.toString();
    return `${Global.url}tareas/dashboard-global${q ? `?${q}` : ""}`;
  };

  const cargarUsuarios = async () => {
    try {
      const res = await fetch(`${Global.url}usuarios/todos`, { headers: authHeaders() });
      const data = await res.json().catch(() => []);
      if (res.ok && Array.isArray(data)) {
        const mapa = {};
        data.forEach((u) => (mapa[u.id] = u));
        setUsuariosMapa(mapa);
      }
    } catch (e) {
      console.error("Error cargando usuarios:", e);
    }
  };

  const cargarDashboard = async () => {
    setCargando(true);
    try {
      const endpoint = construirEndpoint();
      const res = await fetch(endpoint, { headers: authHeaders() });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        console.error("Error dashboard:", data);
        mostrarToast("error", data.message || "No se pudo cargar el dashboard");
        setDashboard(null);
        return;
      }
      setDashboard(data || null);
    } catch (e) {
      console.error("Error cargando dashboard:", e);
      mostrarToast("error", "Error de red al cargar el dashboard");
      setDashboard(null);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    cargarUsuarios();
    cargarDashboard();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const kpis = dashboard?.kpis || {};
  const prioritarias = Array.isArray(dashboard?.prioritariasPendientes) ? dashboard.prioritariasPendientes : [];
  const vencidas = Array.isArray(dashboard?.vencidas) ? dashboard.vencidas : [];
  const sinResponsable = Array.isArray(dashboard?.sinResponsable) ? dashboard.sinResponsable : [];
  const byDepto = Array.isArray(dashboard?.byDepartamento) ? dashboard.byDepartamento : [];

  const topDeptos = useMemo(() => byDepto.slice(0, 12), [byDepto]);

  // ---- Panel gestionar ----
  const cargarUsuariosDelDepto = async (departamentoId) => {
    if (!departamentoId) {
      setUsuariosDepto([]);
      return;
    }
    setCargandoUsuariosDepto(true);
    try {
      const res = await fetch(`${Global.url}departamentos/${departamentoId}/usuarios`, {
        headers: authHeaders(),
      });
      const data = await res.json().catch(() => []);
      if (res.ok && Array.isArray(data)) {
        const activos = data.filter((u) => u.miembro_activo !== false);
        setUsuariosDepto(activos);
      } else {
        setUsuariosDepto([]);
      }
    } catch (e) {
      console.error("Error cargando usuarios depto:", e);
      setUsuariosDepto([]);
    } finally {
      setCargandoUsuariosDepto(false);
    }
  };

  const abrirPanel = async (item) => {
    setItemPanel(item);
    setPanelAbierto(true);

    setSelectedUsuarioId(item?.asignado_a_usuario_id ? String(item.asignado_a_usuario_id) : "");
    setNuevoEstado(item?.estado || "pendiente");
    setComentarioAccion("");

    await cargarUsuariosDelDepto(item?.departamento_id);
  };

  const cerrarPanel = () => {
    setPanelAbierto(false);
    setItemPanel(null);
    setUsuariosDepto([]);
    setSelectedUsuarioId("");
    setNuevoEstado("");
    setComentarioAccion("");
    setGuardandoPanel(false);
  };

  const guardarPanel = async () => {
    if (!itemPanel) return;

    const peticionId = itemPanel.peticion_id;

    const asignPrev = itemPanel.asignado_a_usuario_id || null;
    const asignNuevo = selectedUsuarioId ? Number(selectedUsuarioId) : null;

    const hayCambioAsignacion = asignNuevo !== asignPrev;
    const hayCambioEstado = nuevoEstado && nuevoEstado !== itemPanel.estado;

    const hayComentario = typeof comentarioAccion === "string" && comentarioAccion.trim().length > 0;
    const comentario = hayComentario ? comentarioAccion.trim() : undefined;

    if (!hayCambioAsignacion && !hayCambioEstado && !hayComentario) {
      mostrarToast("info", "No hay cambios que aplicar.");
      return;
    }

    setGuardandoPanel(true);

    try {
      // 1) asignación / comentario (aunque solo sea comentario)
      if (hayCambioAsignacion || hayComentario) {
        const body = {
          ...(hayCambioAsignacion && { asignado_a_usuario_id: asignNuevo }),
          ...(hayComentario && { comentario }),
        };

        const res = await fetch(`${Global.url}peticiones/${peticionId}`, {
          method: "PATCH",
          headers: authHeadersJson(),
          body: JSON.stringify(body),
        });

        const data = await res.json().catch(() => ({}));
        if (!res.ok) {
          console.error("Error asignación/comentario:", data);
          mostrarToast("error", data.message || "No se pudo guardar la asignación/comentario");
          setGuardandoPanel(false);
          return;
        }
      }

      // 2) cambio de estado
      if (hayCambioEstado) {
        const res = await fetch(`${Global.url}tareas/peticiones/${peticionId}/estado`, {
          method: "PATCH",
          headers: authHeadersJson(),
          body: JSON.stringify({
            estado: nuevoEstado,
            ...(hayComentario && { comentario }),
          }),
        });

        const data = await res.json().catch(() => ({}));
        if (!res.ok) {
          console.error("Error estado:", data);
          mostrarToast("error", data.message || "No se pudo cambiar el estado");
          setGuardandoPanel(false);
          return;
        }
      }

      mostrarToast("ok", "Cambios aplicados.");
      cerrarPanel();
      await cargarDashboard();
    } catch (e) {
      console.error("Error guardando panel:", e);
      mostrarToast("error", "Error de red al guardar los cambios.");
    } finally {
      setGuardandoPanel(false);
    }
  };

  const renderItemCard = (item) => {
    const depto = item.departamento_nombre || "Sin departamento";
    const responsable =
      item.asignado_a_usuario_id && usuariosMapa[item.asignado_a_usuario_id]
        ? `${usuariosMapa[item.asignado_a_usuario_id].nombre || ""} ${usuariosMapa[item.asignado_a_usuario_id].apellidos || ""}`.trim()
        : null;

    const creador =
      item.creador_id && usuariosMapa[item.creador_id]
        ? usuariosMapa[item.creador_id]
        : null;

    return (
      <div key={item.peticion_id} className="kanban-card" style={{ marginBottom: 10 }}>
        {/* Cabecera mini */}
        <div className="kanban-card-header">
          <div className="kanban-card-avatar">
            {creador ? (
              <div className="avatar-fallback avatar-fallback--small">{getIniciales(creador)}</div>
            ) : (
              <div className="avatar-fallback avatar-fallback--small">?</div>
            )}
          </div>
          <div className="kanban-card-header-text">
            <span className="kanban-card-creator-name">
              {creador
                ? `${creador.nombre || ""} ${creador.apellidos || ""}`.trim()
                : "Creador desconocido"}
            </span>
            <span className="kanban-card-creator-label">Creador</span>
          </div>
        </div>

        <div className="kanban-card-title">{item.titulo}</div>

        <div style={{ marginTop: 6, display: "flex", gap: 8, flexWrap: "wrap" }}>
          <span className={badgePrioridadClass(item.prioridad)}>{item.prioridad || "normal"}</span>
          <span className="kanban-depto-tag" style={{ fontSize: 12 }}>{depto}</span>
          <span style={{ fontSize: 12, opacity: 0.85 }}>
            Estado: <strong>{item.estado}</strong>
          </span>
        </div>

        <div style={{ marginTop: 6, fontSize: 13 }}>
          Responsable:{" "}
          <strong>{responsable || "Sin asignar"}</strong>
        </div>

        {item.fecha_vencimiento && (
          <div style={{ marginTop: 6, fontSize: 12, opacity: 0.85 }}>
            Vence: {formatearFechaCompleta(item.fecha_vencimiento)}
          </div>
        )}

        <div className="kanban-card-actions" style={{ marginTop: 10 }}>
          <button
            type="button"
            className="kanban-card-config-btn"
            onClick={() => abrirPanel(item)}
          >
            ⚙ Gestionar
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="kanban-wrapper">
      {toast && <Toast type={toast.type}>{toast.text}</Toast>}

      <h2 className="centrar-titulo">Dashboard global</h2>

      {/* Filtros opcionales */}
      <div className="form-group-inline" style={{ marginBottom: 14 }}>
        <div style={{ flex: 1, marginRight: 8 }}>
          <label>Desde (opcional)</label>
          <input
            className="input-layout"
            type="date"
            value={desde}
            onChange={(e) => setDesde(e.target.value)}
          />
        </div>
        <div style={{ flex: 1, marginLeft: 8 }}>
          <label>Hasta (opcional)</label>
          <input
            className="input-layout"
            type="date"
            value={hasta}
            onChange={(e) => setHasta(e.target.value)}
          />
        </div>
        <div style={{ display: "flex", alignItems: "flex-end", gap: 8 }}>
          <button type="button" className="btn-login" onClick={cargarDashboard} disabled={cargando}>
            {cargando ? "Cargando..." : "Aplicar"}
          </button>
          <button
            type="button"
            className="btn-secundario"
            onClick={() => {
              setDesde("");
              setHasta("");
              setTimeout(cargarDashboard, 0);
            }}
            disabled={cargando}
          >
            Limpiar
          </button>
        </div>
      </div>

      {cargando ? (
        <p>Cargando dashboard…</p>
      ) : !dashboard ? (
        <p style={{ fontStyle: "italic" }}>No hay datos para mostrar.</p>
      ) : (
        <>
          {/* KPIs */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(210px, 1fr))", gap: 12 }}>
            <div className="kanban-card" style={{ padding: 14 }}>
              <div style={{ fontWeight: 700, opacity: 0.8 }}>Abiertas</div>
              <div style={{ fontSize: 26, fontWeight: 800 }}>{kpis.abiertas ?? 0}</div>
              <div style={{ fontSize: 12, opacity: 0.75 }}>Pendiente + En curso</div>
            </div>

            <div className="kanban-card" style={{ padding: 14 }}>
              <div style={{ fontWeight: 700, opacity: 0.8 }}>Vencidas (abiertas)</div>
              <div style={{ fontSize: 26, fontWeight: 800 }}>{kpis.vencidas ?? 0}</div>
              <div style={{ fontSize: 12, opacity: 0.75 }}>Con fecha vencida</div>
            </div>

            <div className="kanban-card" style={{ padding: 14 }}>
              <div style={{ fontWeight: 700, opacity: 0.8 }}>Sin responsable</div>
              <div style={{ fontSize: 26, fontWeight: 800 }}>{kpis.sin_responsable ?? 0}</div>
              <div style={{ fontSize: 12, opacity: 0.75 }}>Abiertas y sin asignación</div>
            </div>

            <div className="kanban-card" style={{ padding: 14 }}>
              <div style={{ fontWeight: 700, opacity: 0.8 }}>Sin tocar 48h</div>
              <div style={{ fontSize: 26, fontWeight: 800 }}>{kpis.sin_tocar_48h ?? 0}</div>
              <div style={{ fontSize: 12, opacity: 0.75 }}>Abiertas sin actividad reciente</div>
            </div>
          </div>

          {/* Secciones */}
          <div style={{ marginTop: 18, display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))", gap: 16 }}>
            {/* Prioritarias */}
            <div>
              <h3 style={{ marginBottom: 8 }}>Prioritarias pendientes (alta/crítica)</h3>
              {prioritarias.length === 0 ? (
                <p style={{ fontStyle: "italic" }}>No hay tareas prioritarias abiertas.</p>
              ) : (
                prioritarias
                  .slice()
                  .sort((a, b) => sortPrioridad(a.prioridad) - sortPrioridad(b.prioridad))
                  .map(renderItemCard)
              )}
            </div>

            {/* Vencidas */}
            <div>
              <h3 style={{ marginBottom: 8 }}>Vencidas (abiertas)</h3>
              {vencidas.length === 0 ? (
                <p style={{ fontStyle: "italic" }}>No hay tareas vencidas.</p>
              ) : (
                vencidas.map(renderItemCard)
              )}
            </div>

            {/* Sin responsable */}
            <div>
              <h3 style={{ marginBottom: 8 }}>Sin responsable (abiertas)</h3>
              {sinResponsable.length === 0 ? (
                <p style={{ fontStyle: "italic" }}>No hay tareas abiertas sin responsable.</p>
              ) : (
                sinResponsable.map(renderItemCard)
              )}
            </div>

            {/* Por departamento */}
            <div>
              <h3 style={{ marginBottom: 8 }}>Abiertas por departamento (top)</h3>
              <div className="kanban-card" style={{ padding: 12 }}>
                {topDeptos.length === 0 ? (
                  <p style={{ fontStyle: "italic" }}>No hay datos por departamento.</p>
                ) : (
                  <div style={{ display: "grid", gap: 8 }}>
                    {topDeptos.map((d) => (
                      <div
                        key={`${d.departamento_id}-${d.departamento_nombre}`}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          gap: 10,
                        }}
                      >
                        <div style={{ fontWeight: 600 }}>
                          {d.departamento_nombre || "Sin departamento"}
                        </div>
                        <div style={{ fontSize: 13, opacity: 0.9 }}>
                          <strong>{d.abiertas}</strong> abiertas
                          {typeof d.vencidas === "number" && d.vencidas > 0 ? (
                            <span style={{ marginLeft: 10 }}>
                              · <strong>{d.vencidas}</strong> vencidas
                            </span>
                          ) : null}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}

      {/* MODAL PANEL DE GESTIÓN */}
      {panelAbierto && itemPanel && (
        <div className="modal-overlay" style={{ zIndex: 999999 }}>
          <div className="modal-content modal-config-tarea">
            <button className="modal-close" onClick={cerrarPanel}>
              &times;
            </button>

            <h3 className="centrar-titulo">
              Gestionar petición #{itemPanel.peticion_id}
            </h3>

            <p style={{ marginBottom: 6 }}>
              <strong>Tarea:</strong> {itemPanel.titulo}
            </p>
            <p style={{ marginBottom: 6 }}>
              <strong>Departamento:</strong> {itemPanel.departamento_nombre || "Sin departamento"}
            </p>

            <p style={{ marginBottom: 6 }}>
              <strong>Estado actual:</strong> {itemPanel.estado}
            </p>

            <p style={{ marginBottom: 10 }}>
              <strong>Responsable actual:</strong>{" "}
              {itemPanel.asignado_a_usuario_id && usuariosMapa[itemPanel.asignado_a_usuario_id]
                ? `${usuariosMapa[itemPanel.asignado_a_usuario_id].nombre || ""} ${
                    usuariosMapa[itemPanel.asignado_a_usuario_id].apellidos || ""
                  }`.trim()
                : "Sin responsable"}
            </p>

            <hr style={{ margin: "10px 0" }} />

            <div className="form-group-inline">
              <div style={{ flex: 1, marginRight: 8 }}>
                <label>Reasignar a:</label>
                {cargandoUsuariosDepto ? (
                  <p>Cargando usuarios del departamento…</p>
                ) : usuariosDepto.length === 0 ? (
                  <p style={{ fontStyle: "italic" }}>
                    No hay miembros activos en este departamento (o la tarea no tiene depto).
                  </p>
                ) : (
                  <select
                    className="input-layout"
                    value={selectedUsuarioId}
                    onChange={(e) => setSelectedUsuarioId(e.target.value)}
                  >
                    <option value="">Sin responsable</option>
                    {usuariosDepto.map((u) => (
                      <option key={u.id} value={u.id}>
                        {`${u.nombre || ""} ${u.apellidos || ""}`.trim()}
                      </option>
                    ))}
                  </select>
                )}
              </div>

              <div style={{ flex: 1, marginLeft: 8 }}>
                <label>Estado de la petición:</label>
                <select
                  className="input-layout"
                  value={nuevoEstado}
                  onChange={(e) => setNuevoEstado(e.target.value)}
                >
                  {ESTADOS.map((e) => (
                    <option key={e.id} value={e.id}>
                      {e.titulo}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <label style={{ marginTop: 12 }}>Comentario:</label>
            <textarea
              className="input-layout"
              rows={3}
              value={comentarioAccion}
              onChange={(e) => setComentarioAccion(e.target.value)}
              placeholder="Añade contexto (aunque no cambies asignación/estado)…"
            />

            <div style={{ marginTop: 16, display: "flex", justifyContent: "flex-end", gap: 8 }}>
              <button
                type="button"
                className="btn-secundario"
                onClick={cerrarPanel}
                disabled={guardandoPanel}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="btn-login"
                onClick={guardarPanel}
                disabled={guardandoPanel}
              >
                {guardandoPanel ? "Guardando..." : "Guardar cambios"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardGlobal;
